<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/customerList' }"
          >客户企业管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          formData.id ? "编辑客户企业" : "新增客户企业"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>{{ formData.id ? "编辑客户企业" : "新增客户企业" }}</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>客户企业名称</p>
            <div class="input_box">
              <el-input
                v-model="formData.bodyname"
                placeholder="输入客户企业名称"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>企业简介</p>
            <div class="input_box">
              <el-input
                type="textarea"
                v-model="formData.bodyintro"
                placeholder="输入企业简介"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p>所在地区</p>
            <div class="select_box">
              <el-select
                v-model="formData.bodyprovince"
                placeholder="选择省/直辖市"
                @visible-change="getProvince"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.bodycity"
                placeholder="选择城市"
                @visible-change="getCity"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityid"
                  :label="item.cityname"
                  :value="item.cityid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.bodyarea"
                placeholder="选择所在区域"
                @visible-change="getArea"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.addrid"
                  :label="item.addrname"
                  :value="item.addrid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.bodyaddr"
                placeholder="请填写详细地址，50个字符内"
                type="textarea"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p>所属行业</p>
            <div class="select_box">
              <el-select
                v-model="formData.label1"
                @change="handleLabel1Change"
                @focus="getQyFirstLevelLabel()"
                placeholder="请选择一级行业标签"
              >
                <el-option
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                  v-for="item in oneLabelList"
                ></el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.label2"
                placeholder="请选择二级行业标签"
                @focus="getQyTwoLevelLabel()"
                @change="handleLabel2Change"
              >
                <el-option
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                  v-for="item in twoLabelList"
                ></el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.label3"
                @change="handleLabel3Change"
                @focus="getQyThreeLevelLabel()"
                placeholder="请选择三级行业标签"
              >
                <el-option
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                  v-for="item in threeLabelList"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="block">
            <p>是否启用</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.isuse"
                style="justify-content: space-evenly"
              >
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">停用 </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  encryptstringview,
  getCustomerBodyDetail,
  addCustomerBody,
  editCustomerBody,
} from "../../../api/api";
import {
  getQyFirstLevelLabel,
  getQyTwoLevelLabel,
  getQyThreeLevelLabel,
} from "../../../api/company";
export default {
  name: "customerDetail",
  data() {
    return {
      loading: false,
      formData: {
        id: "",
        bodyname: "",
        qyguid: "",
        bodyintro: "",
        bodyprovince: "",
        bodycity: "",
        bodyarea: "",
        bodyaddr: "",
        label1: "",
        label2: "",
        label3: "",
        isuse: "0",
        qycreateuser: "",
      },

      classidOption: [], // 补充分类
      userattrOption: [], // 客户属性
      contactsortOption: [], // 联系优先度
      customerOptin: [], // 客户标签
      customerQy: [], // 企业

      provinceList: [],
      provinceTxtL: "",
      cityList: [],
      areaList: [],
      //   一级标签
      oneLabelList: [],
      //   二级标签
      twoLabelList: [],
      // 三级标签
      threeLabelList: [],
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy.qyguid;
    this.formData.qycreateuser = USERINFO.truename;
    this.getProvince()
    this.getQyFirstLevelLabel()
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getCustomerBodyDetail();
      } else {
        this.$router.back();
      }
    },
    // 获取详情
    getCustomerBodyDetail() {
      getCustomerBodyDetail({ id: this.formData.id }).then((res) => {
        this.detail = res;
        this.formData.bodyname = res.bodyname;
        this.formData.qyguid = res.qyguid;
        this.formData.bodyintro = res.bodyintro;
        this.formData.bodyprovince = res.bodyprovince ? parseInt(res.bodyprovince) : "";
        this.formData.bodycity = res.bodycity ? parseInt(res.bodycity) : "";
        this.formData.bodyarea = res.bodyarea ? parseInt(res.bodyarea) : "";
        this.formData.bodyaddr = res.bodyaddr;
        this.formData.label1 = res.label1;
        this.formData.label2 = res.label2;
        this.formData.label3 = res.label3;
        this.formData.isuse = res.isuse;
        this.formData.qycreateuser = res.qycreateuser;
        if(res.bodycity) {
          this.getCity()
        }
        if(res.bodyarea) {
          this.getArea()
        }
        if(res.label2) {
          this.getQyTwoLevelLabel()
        }
        if(res.label3) {
          this.getQyTwoLevelLabel()
        }
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        this.provinceList = res;
        if (!isClick) {
          this.formData.other_city = "";
          this.formData.other_area = "";
          this.cityList = [];
          this.areaList = [];
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.bodyprovince).then((res) => {
        this.cityList = res;
        if (!isClick) {
          this.formData.other_area = "";
          this.areaList = [];
        }
      });
    },
    // 获取区域
    getArea() {
      getArea(this.formData.bodycity).then((res) => {
        this.areaList = res;
      });
    },

    // 获取企业一级标签
    getQyFirstLevelLabel() {
      getQyFirstLevelLabel().then((res) => {
        this.oneLabelList = res;
      });
    },
    // 获取二级标签
    getQyTwoLevelLabel() {
      getQyTwoLevelLabel(this.formData.label1).then((res) => {
        this.twoLabelList = res;
      });
    },
    // 获取三级标签
    getQyThreeLevelLabel() {
      getQyThreeLevelLabel(this.formData.label2).then((res) => {
        this.threeLabelList = res;
      });
    },

    // 一级标签
    handleLabel1Change(e) {
      this.formData.label1 = e;
      this.formData.label2 = "";
      this.formData.label3 = "";
    },
    handleLabel2Change(e) {
      this.formData.label2 = e;
      this.formData.label3 = "";
    },
    handleLabel3Change(e) {
      this.formData.label3 = e;
    },

    query() {
      let { formData } = this;
      if (formData.bodyname == "") {
        this.$message.warning("请输入客户企业名称");
        return;
      }
      // if (formData.info_mobile == "") {
      //   this.$message.warning("请输入联系方式");
      //   return;
      // }
      if (formData.id) {
        this.editCustomerBody();
      } else {
        this.addCustomerBody();
      }
    },

    // 修改
    editCustomerBody() {
      this.loading = true;
      editCustomerBody(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerBody() {
      this.loading = true;
      addCustomerBody(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>